import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { availableTemplateTypes, TemplateTypes, TemplateUploadResponse } from '@tokeet-frontend/signature'

export function createTemplateBasicForm(formBuilder: FormBuilder) {
  return formBuilder.group({
    type: [TemplateTypes.Contract, [Validators.required]],
    uploaded: [[], [Validators.required]],
  })
}

@Component({
  selector: 'app-upload-template',
  templateUrl: './upload-template.component.html',
  styleUrls: ['./upload-template.component.scss'],
})
export class UploadTemplateComponent implements OnInit {
  @Input() form: FormGroup
  @Input() isOnetime: boolean
  @Input() isTypeEditable = true

  availableTemplateTypes = availableTemplateTypes

  types = TemplateTypes
  get templateType() {
    return this.form && this.form.get('type').value
  }

  constructor() {}

  ngOnInit(): void {}

  onChangeType(type: TemplateTypes) {
    this.form.patchValue({ type })
  }

  onTemplateUpload(data: TemplateUploadResponse[]) {
    this.form.patchValue({ uploaded: data })
  }
}
